import { identify } from '@iheartjane/tracking';
import type { Nullish } from '@iheartjane/types';
import isEqual from 'lodash-es/isEqual';
import pick from 'lodash-es/pick';

import type { AppStore } from '../customer/redux';

function identifyBusinessUser({ id }: { id: Nullish<number> }) {
  const businessId = `business:${id}`;

  identify(businessId);
}

function identifyCustomerUser({ id }: { id: Nullish<number> }) {
  const customerId = `customer:${id}`;

  identify(customerId);
}

export function identifyAtFirstOpportunity() {
  let lastUser = {};

  return (user: { id: Nullish<number>; nickname?: Nullish<string> }) => {
    if (isEqual(user, lastUser)) return;

    lastUser = user;

    if (user.id && user.nickname) {
      identifyCustomerUser(user);
    } else if (user.id) {
      identifyBusinessUser(user);
    }
  };
}

export const identifyCustomerUserAtFirstOpportunity = (store: AppStore) => {
  const identify = identifyAtFirstOpportunity();

  store.subscribe(() => {
    const user = pick(store.getState().customer, ['id', 'email', 'nickname']);
    identify(user);
  });
};
